import { fetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

export const publishDocumentAssemblerTemplateVersion = async (
  templateId: string,
  versionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${templateVersionsUrl(templateId)}/${versionId}/publish`,
    { method: 'POST', body: {} }
  );
  return res;
};
